import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
import { Header } from "@tanstack/react-table";
import clsx from "clsx";
import React from "react";
import type { ColumnDefinition } from "../QATable";

interface Props<T extends Record<string, unknown>> {
    header: Header<T, unknown>;
    config: ColumnDefinition<T>;
}

const useStyles = makeStyles(() => ({
    textTitle: {
        alignItems: "center",
        justifyContent: "center",
        display: "flex",
        fontSize: "13px"
    },
    sortable: {
        cursor: "pointer"
    }
}));

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const QATableHeaderTitle: React.FC<Props<any>> = props => {
    const classes = useStyles();

    let Icon;
    if (props.header.column.getIsSorted()) {
        Icon = props.header.column.getIsSorted() === "desc" ? ArrowDropDown : ArrowDropUp;
    }

    if (props.config.sortable) {
        return (
            <div
                onClick={props.header.column.getToggleSortingHandler()}
                className={clsx(classes.textTitle, classes.sortable)}>
                {props.config.title}
                {Icon && <Icon fontSize="small" />}
            </div>
        );
    }

    return (
        <div
            className={classes.textTitle}>
            {props.config.title}
        </div>
    );
};

export default QATableHeaderTitle;
